import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { EMPTY, Observable, of } from 'rxjs';
import { switchMap, catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';

import { HomeItemDetailService } from '@home-item-detail/services/home-item-detail.service';
import {
  fetchHomeFlightOffersAction,
  fetchHomeFlightOffersSuccessAction,
  fetchHomeItemDetailAction,
  fetchHomeItemDetailSuccessAction
} from '@home-item-detail/store/actions/home-item-detail.actions';
import { setBranchCodeAction } from '@shared/base-search-bar/store/actions/search-bar.actions';
import { AppFacade } from '@app/app.facade';
import { homeRootRoute } from '@home/home-routing.module';
import { setCloseWebViewInDetailAction } from '@app/store/actions/global.actions';
import { LoginType } from '@app/entities/login-type';
import { HeaderService } from '@app/modules/core/header/services/header.service';

@Injectable()
export class HomeItemDetailStoreEffects {

  constructor(
    private router: Router,
    private action$: Actions,
    private appFacade: AppFacade,
    private readonly service: HomeItemDetailService,
    private readonly headerService: HeaderService,
  ) { }

  fetchHomeItemDetail$: Observable<Action> = createEffect(() => this.action$
    .pipe(
      ofType(fetchHomeItemDetailAction),
      switchMap(action => this.service.fetchHomeItemDetail(action.payload).pipe(
        switchMap(response => this.appFacade.isLoggedIn$.pipe(
          switchMap(isLoggedIn => {
            if (!response.login_required || isLoggedIn) {
              return [
                setBranchCodeAction({ branchCode: response.branch_code }),
                setCloseWebViewInDetailAction({ payload: response.back_link }),
                fetchHomeItemDetailSuccessAction({ response: response })
              ];
            } else {
              this.headerService.forceUserLogin(LoginType.Anywhere);
              return [];
            }
          })
        )),
        catchError(() => this.ErrorAction())
      ))
    ));

  fetchHomeFlightOffersAction$: Observable<Action> = createEffect(() => this.action$
    .pipe(
      ofType(fetchHomeFlightOffersAction),
      switchMap(action =>
        this.service.fetchFlightOffers(action.departure, action.arrival, action.isOneWay).pipe(
          map(response => fetchHomeFlightOffersSuccessAction({ response: response }))
        )
      ),
      catchError(() => {
        return EMPTY;
      })
    ));

  private ErrorAction(): Observable<never> {
    this.appFacade.historyPop();
    this.router.navigate([homeRootRoute]);
    return of();
  }

}
